import React, { useState, useEffect, Fragment } from 'react';
import * as Icons from '../Icons';
import { withRouter, Link, useLocation } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Register from '../seller/register';


function rand() {
  return Math.round(Math.random() * 20) - 10;
}

function getModalStyle() {
  const top = 50 + rand();
  const left = 50 + rand();

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
    position: 'fixed',

  };
}

const useStyles = makeStyles(theme => ({
  paper: {
    position: 'fixed',
    width: 550,
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2, 4, 3),

    outline: 'none',
  }

}));

const Navbar = ({ history }) => {
  const classes = useStyles();
  const location = useLocation()

  const [modalStyle] = React.useState(getModalStyle);
  const [open, setOpen] = React.useState(false);
  const body = (
    <div style={modalStyle} className={classes.paper}>
      <Register />
    </div>
  );


  useEffect(() => {
    var scrollTrigger = 50;
    document.querySelector('body').classList.add('scroller');
    function arrangePage() {
      if (window.scrollY > scrollTrigger) {
        document.querySelector('body').classList.add('navbar-threshold');
      }
      if (window.scrollY < scrollTrigger) {
        document.querySelector('body').classList.remove('navbar-threshold');
      }
    }

    window.addEventListener('scroll', arrangePage);

    return () => {
      document.querySelector('body').classList.remove('scroller');
      window.removeEventListner &&
        window.removeEventListner('scroll', () => {
          if (setFromEvent) {
            setFromEvent();
          }
        });
    };
  }, []);

  const [activeIndex, setActiveIndex] = useState(0);
  const links = [
    { name: 'Home', section: '#home' },
    { name: 'Our Services', section: '#services' },
    { name: 'Features', section: '#features' },
    { name: 'Screens', section: '#screens' },
    { name: 'Download', section: '#download-app' },
    { name: 'Reviews', section: '#reviews' },
  ];

  useEffect(() => {
    if (location.pathname === "/" && location.hash) {
      document.querySelector(location.hash).scrollIntoView({
        behaviour: 'smooth'
      });
    }
  }, [location.hash, location.pathname])

  const setActive = index => {
    setOpen(!open);
    setActiveIndex(index);
  };

  let tog = open === true ? 'show' : 'hide';
  return (
    <nav className="navbar navbar-expand-lg fixed-top" id="mainNav">
      <div className="container">
        <Link className="navbar-brand" to="/">
          <img src={Icons.Abc} />
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#siteMenu"
          aria-controls="siteMenu"
          aria-expanded="true"
          aria-label="Toggle navigation"
          onClick={() => setOpen(!open)}
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className={`collapse navbar-collapse ${tog}`} id="siteMenu" style={{ justifyContent: 'flex-end' }}>
          <ul className="navbar-nav ml-auto">
            {links.map((link, index) => {
              let activeClass = index === activeIndex ? 'active' : '';
              return (
                <Fragment key={index}>
                  <li className="nav-item">
                    <Link className={`nav-link ${activeClass}`}
                      to={`/${link.section}`}
                      key={index}
                      onClick={e => setActive(index)}
                    >{link.name}</Link>
                  </li>
                </Fragment>
              );
            })}
            {/* <li><Register /></li> */}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default withRouter(Navbar);
